import React from "react";
import { useNavigate } from "react-router-dom";

// 공지사항 페이지의 공지사항 박스
export const NoticeBox = ({noticeData}) => {

    const navigate = useNavigate();

    // 프롭으로 전달 받은 공지사항 데이터 중 박스에 필요한 데이터만 구조분해 할당
    const { 
            _id:noticeId,            // 공지사항 ID
            thumbnailURL,   // 공지사항 썸네일 URL
            title,          // 제목
        } = noticeData;

    // const typeName = typeList(type) // 공지사항 타입 이름으로 변경

    const onClickBox = () => {
        navigate('/notice/detail', { state: noticeData });
    }

    return (
        <label htmlFor={noticeId} className="noticeBox">
            <input type="button" id={noticeId} onClick={onClickBox} hidden/>
            <img src={thumbnailURL} alt=""/>
            <div className="noticeTitle">{title}</div>
        </label>
    )
}

export default NoticeBox;